import React from 'react';
import { connect } from 'react-redux';

import MenuItemChoiceSelection from '../../common/menuitem/MenuItemChoiceSelection';
import { cartItemLoadSpecialItems } from '../../../actions/cartItem';
import { setSpecialPanel } from '../../../actions/panels';

class ViewPizzaCrusts extends React.Component {
    

    printCrustPrice(theCrust) {
        if (parseFloat(theCrust.price) > 0) {
            return " - "+theCrust.price;
        }

        return "";
    }

    updateCrust(theCrust) {

        const updatedSpecialItems = this.props.cartItem.items.map((theCartItem, theIndex) => {
            if (this.props.index == theIndex) {

                // this is our item, let's update the crust_id
                theCartItem.crust_id = theCrust.id;
            }

            return theCartItem;
        });

        this.props.dispatch(cartItemLoadSpecialItems(updatedSpecialItems));
    }

    render() {

        return (
            <div className="menu-item-window menu-item-list">
                {this.props.specialPizza.crusts.map((crust) => (
                    <MenuItemChoiceSelection
                        onChoicePress={() => { 
                            this.updateCrust(crust);
                            this.props.dispatch(setSpecialPanel('pizza'));
                        }}
                    >
                        {crust.name+this.printCrustPrice(crust)}
                    </MenuItemChoiceSelection>
                ))}
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        special: state.currentMenuItem.item,
        cartItem: state.cartItem
    };
};


export default connect(mapStateToProps)(ViewPizzaCrusts);
